/**
 * Runs before Vue/router so a Küchen-PWA opened at partner start_url (/) lands on /kueche.
 */
import { hydrateKitchenStorageFromCookies } from '@/utils/kitchenBindCookie';
import {
  getKitchenBindToken,
  hasKitchenBindToken,
  hasKitchenPwaManifestFlag,
} from '@/utils/kitchenBinding';
import { isStandalonePwa } from '@/utils/pwaStandalone';

const isKitchenPath = (path) => path === '/kueche' || path.startsWith('/kueche/');

export function applyKitchenStandaloneLaunchRedirect() {
  if (typeof window === 'undefined') return;

  hydrateKitchenStorageFromCookies();

  const path = window.location.pathname || '';
  if (isKitchenPath(path)) return;
  if (!isStandalonePwa()) return;

  if (hasKitchenBindToken()) {
    const token = getKitchenBindToken();
    const target = token
      ? `/kueche?bind=${encodeURIComponent(token)}`
      : '/kueche';
    window.location.replace(target);
    return;
  }

  if (hasKitchenPwaManifestFlag()) {
    window.location.replace('/kueche/ungueltig');
  }
}

applyKitchenStandaloneLaunchRedirect();
